import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import logo from "../../assets/logonew.png"; // Adjust path as needed

const links = [
  { linkName: "Services", link: "/service" },
  { linkName: "Projects", link: "/projects" },
  { linkName: "About", link: "/about" },
  { linkName: "Contact", link: "/contact" },
  { linkName: "Industry", link: "/industries" },
  { linkName: "Blog", link: "/blog" },
 
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [isNavbarHidden, setIsNavbarHidden] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > prevScrollY && currentScrollY > 50) {
        setIsNavbarHidden(true);
      } else {
        setIsNavbarHidden(false);
      }
      setIsScrolled(currentScrollY > 50);
      setPrevScrollY(currentScrollY);
    };

    const closeMobileMenuOnClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest(".mobile-menu") && !event.target.closest(".hamburger-menu")) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", closeMobileMenuOnClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", closeMobileMenuOnClickOutside);
    };
  }, [prevScrollY, isMobileMenuOpen]);

  return (
    <>
      <nav className={`navbar ${isNavbarHidden ? "hidden" : ""} ${isScrolled ? "scrolled" : ""}`}>
        <div className="nav-content">
          {/* Left Links */}
          <div className="nav-links">
            {links.slice(0, 3).map((el, index) => (
              <a
                key={el.linkName}
                href={el.link}
                className={`nav-link ${location.pathname === el.link ? "active" : ""}`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {el.linkName}
                <hr className="nav-underline" style={{ width: location.pathname === el.link ? "100%" : hoveredIndex === index ? "60px" : "0px" }} />
              </a>
            ))}
          </div>

          {/* Logo */}
          <div className="logo-container">
            <a href="/">
              <img src={logo} alt="Logo" className="logo" />
            </a>
          </div>

          {/* Right Links */}
          <div className="nav-links">
            {links.slice(3).map((el, index) => (
              <a
                key={el.linkName}
                href={el.link}
                className={`nav-link ${location.pathname === el.link ? "active" : ""}`}
                onMouseEnter={() => setHoveredIndex(index + 3)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {el.linkName}
                <hr className="nav-underline" style={{ width: location.pathname === el.link ? "100%" : hoveredIndex === index + 3 ? "60px" : "0px" }} />
              </a>
            ))}
          </div>

          {/* Hamburger Menu */}
          <button className="hamburger-menu" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? "✖" : "☰"}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        {links.map((el) => (
          <a key={el.linkName} href={el.link} className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            {el.linkName}
          </a>
        ))}
      </div>

      {/* Styles */}
      <style>
        {`
          .navbar {
            position: fixed;
            top: 0;
            width: 100%;
            background: transparent;
            padding: 10px 0;
            transition: transform 0.3s ease-in-out, background 0.3s ease-in-out;
            z-index: 1000;
          }

          .navbar.scrolled {
            background: white;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
          }

          .nav-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1100px;
            margin: 0 auto;
            padding: 0 20px;
            height: 60px;
          }

          .nav-links {
            display: flex;
            gap: 100px;
          }

          .nav-link {
            text-decoration: none;
            color: white;
            font-weight: 600;
            font-size: 14px;
            position: relative;
            transition: color 0.3s ease;
          }

          .scrolled .nav-link {
            color: black;
          }

          .nav-link.active {
            font-weight: bold;
            
          }

          .nav-underline {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -15px;
            height: 3px;
            width: 20px;
            background-color: #5c0e14;
            border: none;
            transition: width 0.3s ease-in-out;
          }

          .logo-container {
            flex-grow: 1;
            display: flex;
            justify-content: center;
          }

          .logo {
            height: 45px;
            transition: all 0.3s ease-in-out;
          }
.hamburger-menu {
  background: transparent; /* Transparent background */
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 1100; /* Ensure it's above other elements */
  position: relative;
  color: black; /* Default color */
  transition: transform 0.3s ease-in-out, color 0.3s ease-in-out;
   display: none;
}
 


/* ✅ When the menu is open, hide the hamburger icon */
.mobile-menu.open + .hamburger-menu {
  display: none;
}

/* ✅ Rotate and change color when open */
.hamburger-menu.open {
  transform: rotate(180deg);
  color: red; /* Change color when open */
}

/* ✅ Hover effect for better UX */
.hamburger-menu:hover {
  color: #bf1e2e; /* Red hover color */
  transform: scale(1.1);
}

          .mobile-menu {
            position: fixed;
            top: 80px;
            left: 0;
            width: 100%;
            background: white;
            padding: 15px 0;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
            z-index: 1000;
            display: none;
          }

          .mobile-menu.open {
            display: flex;
          }

          .mobile-link {
            text-decoration: none;
            color: black;
            font-weight: 600;
            font-size: 14px;
          }

          @media screen and (max-width: 1024px) {
  .nav-links {
    display: flex;
    gap: 100px; /* Reduce gap */
    
  }

  .nav-link {
    font-size: 10px;
    font-weight: 300;
  }

  .nav-content {
    //flex-direction: column; /* Stack items */
    align-items: center;
    font-size: 10px;
  }

  .logo {
    height: 40px; /* Adjust logo size */
  }
}

          @media screen and (max-width: 920px) {
            .nav-links {
              display: none;
            }

            .hamburger-menu {
              display: block;
            }

            .mobile-menu {
              display: none;
              flex-direction: column;
              align-items: center;
              gap: 30px;
            }

            .mobile-menu.open {
              display: flex;
            }
          }
        `}
      </style>
    </>
  );
};

export default Navbar;
